/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * LocaleSelector Theme
 *
 * Supports two variants:
 * - Desktop: Popover with bold active item
 * - Mobile: Bottom Drawer with Radio buttons and blur backdrop
 */
export default {
  baseStyle: {
    container: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    button: {
      backgroundColor: 'transparent',
      padding: 0,
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      minWidth: 'auto',
      height: {base: 'auto', lg: '48px'},
      _hover: {
        backgroundColor: 'transparent',
      },
      _active: {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      boxSize: {base: '20px', lg: '24px'},
      color: 'brandColors.greyscale',
    },
    localeText: {
      color: 'brandColors.greyscale',
      fontSize: '14px',
      fontWeight: 'normal',
    },
    divider: {
      borderColor: 'brandColors.greyscale20',
      margin: 0,
    },
    // ==========================================
    // Desktop Popover Styles
    // ==========================================
    popoverContent: {
      borderRadius: 'md',
      boxShadow: 'lg',
      border: '1px solid',
      borderColor: 'brandColors.greyscale20',
      _focus: {
        boxShadow: 'lg',
      },
    },
    popoverItem: {
      padding: 4,
      transition: 'background-color 0.2s',
      _hover: {
        backgroundColor: 'brandColors.greyscale10',
      },
    },
    popoverItemActive: {
      backgroundColor: 'brandColors.secondaryBG',
    },
    popoverItemText: {
      fontSize: 'md',
      fontWeight: 'bold',
      color: 'brandColors.greyscale',
    },
    // ==========================================
    // Mobile Drawer (Bottom Sheet) Styles
    // ==========================================
    drawerOverlay: {
      backdropFilter: 'blur(4px)',
      backgroundColor: 'blackAlpha.300',
    },
    drawerContent: {
      borderRadius: 'xl',
      maxHeight: '80vh',
      marginX: '20px',
      marginBottom: 5,
      width: 'calc(100% - 40px)',
    },
    drawerBody: {
      padding: 0,
    },
    drawerFooter: {
      borderTopWidth: '1px',
      borderTopColor: 'brandColors.greyscale20',
      padding: 4,
    },
    radioItem: {
      padding: 4,
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    radioItemActive: {
      backgroundColor: 'brandColors.secondaryBG',
    },
    radioItemText: {
      fontSize: 'md',
      fontWeight: 'bold',
      color: 'brandColors.greyscale',
    },
    cancelButton: {
      fontSize: 'md',
      fontWeight: 'bold',
      color: 'brandColors.greyscale',
      _hover: {
        backgroundColor: 'brandColors.greyscale10',
      },
    },
  },

  parts: [
    'container',
    'button',
    'icon',
    'localeText',
    'divider',
    'popoverContent',
    'popoverItem',
    'popoverItemActive',
    'popoverItemText',
    'drawerOverlay',
    'drawerContent',
    'drawerBody',
    'drawerFooter',
    'radioItem',
    'radioItemActive',
    'radioItemText',
    'cancelButton'
  ],
};
